import React, { useState } from 'react';
import { FieldArray } from 'formik';
import {
  Button,
  Grid,
  Icon,
  IconButton,
  Switch,
  TextField,
  Typography,
  FormHelperText
} from '@material-ui/core';
import { ConfirmDialog } from 'components';
import { createEmptySurgeon } from './constants';


const GallerySurgeons = ({values, onChange, errors}) => {
  const [surgeonIndexToDelete, setSurgeonIndexToDelete] = useState(null);
  const { surgeons } = values;

  const getNextSurgeonId = () => surgeons.reduce((maxId, surgeon) => Math.max(maxId, Number(surgeon.id) || 0), 0) + 1;

  return (
    <div>
      <FormHelperText className="mb-4">
        Surgeons can be assigned to gallery items and are used for the surgeon filter on the gallery page
      </FormHelperText>
      <FieldArray name="surgeons">
        {(arrayHelpers) => (
          <div>
            {surgeons.map((surgeon, index) => (
              <Grid container spacing={2} className="items-center mb-2" key={`surgeon-${surgeon.id}`}>
                <Grid item xs={12} sm={1}>
                  <Switch
                    color="primary"
                    checked={surgeon.enabled == 1}
                    onChange={(event) => onChange(`surgeons[${index}].enabled`, event.target.checked ? 1 : 0)}
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <TextField
                    className="w-full"
                    variant="outlined"
                    size="small"
                    label="Surgeon Name"
                    value={surgeon.name}
                    error={!!errors?.surgeons?.[index]?.name}
                    helperText={errors?.surgeons?.[index]?.name}
                    onChange={(event) => onChange(`surgeons[${index}].name`, event.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    className="w-full"
                    variant="outlined"
                    size="small"
                    type="number"
                    label="Sort Order"
                    value={surgeon.sort_order}
                    onChange={(event) => onChange(`surgeons[${index}].sort_order`, event.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <IconButton
                    size="small"
                    title="Delete surgeon"
                    onClick={() => setSurgeonIndexToDelete(index)}
                  >
                    <Icon>delete</Icon>
                  </IconButton>
                </Grid>
              </Grid>
            ))}
            {!surgeons.length &&
              <Typography variant="body2" className="my-4">
                No surgeons configured yet
              </Typography>
            }
            <Button
              variant="outlined"
              color="primary"
              className="mt-4"
              onClick={() => arrayHelpers.push(createEmptySurgeon(getNextSurgeonId()))}
            >
              <Icon className="mr-2">add</Icon>
              Add Surgeon
            </Button>
            <ConfirmDialog
              title="Delete Surgeon"
              open={surgeonIndexToDelete !== null}
              setOpen={() => setSurgeonIndexToDelete(null)}
              onClose={() => setSurgeonIndexToDelete(null)}
              onConfirm={() => {
                arrayHelpers.remove(surgeonIndexToDelete);
                setSurgeonIndexToDelete(null);
              }}
            >
              Are you sure you want to delete
              {surgeonIndexToDelete !== null && surgeons[surgeonIndexToDelete]?.name
                ? ` "${surgeons[surgeonIndexToDelete].name}"`
                : ' this surgeon'}?
              It will be unassigned from all gallery items.
            </ConfirmDialog>
          </div>
        )}
      </FieldArray>
    </div>
  );
};

export default GallerySurgeons;
